import Home from './Home';
import Auth from './Auth';
import Account from './Account';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfServices from './TermsOfServices';
import ContactUs from './ContactUs';
import HowWeWork from './HowWeWork';
import FAQs from './FAQs';
export { Auth, ContactUs, Account, PrivacyPolicy, TermsOfServices, HowWeWork, FAQs };
export default Home;

